var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"select-period-container"},[_c('div',{staticClass:"header-container"},[_c('div',{staticClass:"header-content"},[_c('p',[_vm._v(_vm._s(_vm.rangeStr))]),_c('div',{staticClass:"icon-container"},[_c('i',{staticClass:"icon-close",on:{"click":_vm.close}})])])]),_c('calendar-component',{attrs:{"rangeProp":_vm.range}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }